import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css";
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";

export default function Body({
  realtorData,
  loanOfficerActive,
  loanOfficerData,
  angelAiUserInfo,
  newData,
}) {
  const imgCDNURL = process.env.REACT_APP_CDN + "homeownership-program/";

  const francmob = imgCDNURL + "francmob.webp";
  const franctel = imgCDNURL + "franctel.webp";
  const francemail = imgCDNURL + "francemail.webp";
  const francweb = imgCDNURL + "francweb.webp";
  const franclocation = imgCDNURL + "franclocation.webp";

  const { loanOfficer } = newData || {}; // Ensure loanOfficer is from newData

  let mobilePhoneNumberFormatted = "";
  let mobilePhoneNumberWithInternationalCode = "";
  let mobilePhoneNumberInTitle = "";
  let workPhoneNumberFormatted = "";
  let workPhoneNumberWithInternationalCode = "";
  let workPhoneNumberInTitle = "";

  // Mobile phone formatting
  if (loanOfficer?.mobilePhoneNumber) {
    mobilePhoneNumberFormatted = formatPhoneNumber(
      loanOfficer.mobilePhoneNumber
    );
    mobilePhoneNumberWithInternationalCode = addInternationalCode(
      loanOfficer.mobilePhoneNumber,
      "+1"
    );
    mobilePhoneNumberInTitle = `Contact me at ${mobilePhoneNumberFormatted}`;
  }

  // Work phone formatting
  if (loanOfficer?.workPhoneNumber) {
    workPhoneNumberFormatted = formatPhoneNumber(loanOfficer.workPhoneNumber);
    workPhoneNumberWithInternationalCode = addInternationalCode(
      loanOfficer.workPhoneNumber,
      "+1"
    );
    workPhoneNumberInTitle = `Contact me at ${workPhoneNumberFormatted}`;
  }

  return (
    <>
      <div className="">
        <Container>
          {loanOfficer ? (
            <Row>
              <Col sm={12} md={12} xl={12} lg={12} className="loanofficer-col">
                <div className="lo-img-bg">
                  <img
                    src={loanOfficer.profileImage}
                    className="lo-img img-fluid"
                    alt="Loan Officer"
                  />
                  <div className="lo-text">
                    <p className="namejoaqu">{loanOfficer.name}</p>
                    <p className="namejo2">
                      {loanOfficer.nmls && (
                        <>
                          NMLS {loanOfficer.nmls}
                          <br />
                        </>
                      )}
                      {loanOfficer.designation && (
                        <>
                          {loanOfficer.designation}
                          <br />
                        </>
                      )}
                      {/* {loanOfficer.mobilePhoneNumber && (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={`tel:${mobilePhoneNumberWithInternationalCode}`}
                            title={mobilePhoneNumberInTitle}
                          >
                            {mobilePhoneNumberFormatted}
                          </a>
                          <br />
                        </>
                      )} */}
                      {loanOfficer.workPhoneNumber && (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={`tel:${workPhoneNumberWithInternationalCode}`}
                            title={workPhoneNumberInTitle}
                          >
                            D: {workPhoneNumberFormatted}
                          </a>
                          <br />
                        </>
                      )}
                      {loanOfficer.emailAddress && (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={`mailto:${loanOfficer.emailAddress}`}
                            title={`Email me at ${loanOfficer.emailAddress}`}
                          >
                            {loanOfficer.emailAddress}
                          </a>
                          <br />
                        </>
                      )}
                      {loanOfficer.userWebsite && (
                        <>
                          <a
                            style={{ textDecoration: "none" }}
                            href={
                              loanOfficer.userWebsite.startsWith("http://") ||
                              loanOfficer.userWebsite.startsWith("https://")
                                ? loanOfficer.userWebsite
                                : `https://${loanOfficer.userWebsite}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {loanOfficer.userWebsite.replace(
                              /^https?:\/\//,
                              ""
                            )}
                          </a>
                          <br />
                        </>
                      )}
                      {loanOfficer.streetAddress && (
                        <>
                          {loanOfficer.streetAddress}
                          <br /> {loanOfficer.city}, {loanOfficer.state}{" "}
                          {loanOfficer.zipCode}
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Container>
      </div>
      <div id="gettrueapproveScroll"></div>
    </>
  );
}
